import { Box } from '@mui/material';
import {
	FsDialog,
	FsDialogHeader,
	FsDialogBody,
	FsDialogFooter,
} from '../dialog';
import Logo from './logo';

/**
 * Compat shim over the FsDialog design-system primitives (SPEC.md).
 * Keeps the legacy prop surface used by ~29 dialogs while rendering the
 * new FS chrome (green header band, start-aligned title, circular close).
 */
export const DialogWrapper = ({
	state,
	title,
	content,
	actions,
	subTitle = '',
	maxWidth = 'lg',
	width = null,
	showLogo = false,
	loading = false,
	titleClass = '',
	titleTextClass = '',
	subTitleClass = '',
	dialogClass = '',
	disableLogo = false,
	actionFooterClass = '',
	dialogBodyClass = '',
	closeIconClass = '',
	dialogTitleClass = '',
	hideCloseBtn = false,
	preventOutsideClick = false,
	onClose,
	testId = '',
	conatinerScroll,
	containerStyle = {},
}) => {
	return (
		<FsDialog
			state={state}
			onClose={onClose}
			maxWidth={maxWidth}
			width={width}
			preventOutsideClick={preventOutsideClick}
			testId={testId}
			className={dialogClass}
			paperStyle={containerStyle}
			onPaperScroll={conatinerScroll}>
			{showLogo ? (
				<Box className="pb-0 px-4 py-3">
					<Logo disabledLink={disableLogo} sx={{ height: 'auto' }}></Logo>
				</Box>
			) : null}
			{title || !hideCloseBtn ? (
				<FsDialogHeader
					title={title}
					subTitle={subTitle}
					hideCloseBtn={hideCloseBtn}
					onClose={() => {
						onClose && onClose(false);
					}}
					className={dialogTitleClass}
					columnClassName={titleClass}
					titleClassName={titleTextClass}
					subtitleClassName={subTitleClass}
					closeClassName={closeIconClass}
				/>
			) : null}
			<FsDialogBody loading={loading} className={dialogBodyClass}>
				{content}
			</FsDialogBody>
			{actions ? (
				<FsDialogFooter loading={loading} className={actionFooterClass}>
					{actions}
				</FsDialogFooter>
			) : null}
		</FsDialog>
	);
};
